export default __webpack_public_path__ + "static/media/LilaLovelace.13abd15b.png";